import React, { useEffect, useState } from "react";

type Props = {
  value?: number | null; // valor em reais vindo da API
  onChange?: (value: number) => void; // retorna em reais
  className?: string;
  placeholder?: string;
};

export const CurrencyInputBR: React.FC<Props> = ({
  value,
  onChange,
  className,
  placeholder,
}) => {
  // 🔹 sempre trabalhar internamente em CENTAVOS
  const toCents = (val: number) => Math.round(val * 100);

  const [internalValue, setInternalValue] = useState<number>(
    toCents(Number(value ?? 0))
  );

  const [isTyping, setIsTyping] = useState(false);

  // 🔹 sincroniza com API (valor em reais → centavos)
  useEffect(() => {
    if (!isTyping) {
      setInternalValue(toCents(Number(value ?? 0)));
    }
  }, [value]);

  // 🔹 formatação
  const formatBRL = (cents: number) => {
    const reais = cents / 100;

    return reais.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  // 🔥 controle total da digitação
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    setIsTyping(true);

    if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
      e.preventDefault();
      return;
    }

    let newValue = internalValue;

    if (e.key === "Backspace") {
      // 🔹 remove último dígito (padrão financeiro)
      newValue = Math.floor(internalValue / 10);
    } else {
      // 🔹 adiciona dígito à direita
      newValue = internalValue * 10 + Number(e.key);
    }

    setInternalValue(newValue);

    // 🔹 retorna em REAIS (não centavos)
    onChange?.(newValue / 100);

    e.preventDefault(); // 🔥 impede comportamento padrão
  };

  const handleBlur = () => {
    setIsTyping(false);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      value={formatBRL(internalValue)}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      className={className}
      placeholder={placeholder}
    />
  );
};